import { useAuth } from "context/AuthContext";
import { MonitoringPermission } from "hooks/useAccess";

export function useHasPermission(permission: MonitoringPermission): boolean {
  const { user } = useAuth();
  return user?.permissions?.includes(permission) ?? false;
}

export function useHasAnyPermission(...permissions: MonitoringPermission[]): boolean {
  const { user } = useAuth();
  return permissions.some((p) => user?.permissions?.includes(p) ?? false);
}

export function useHasAllPermissions(...permissions: MonitoringPermission[]): boolean {
  const { user } = useAuth();
  return permissions.every((p) => user?.permissions?.includes(p) ?? false);
}
